import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Images/Ciqlercompined2024.png";

/**
 * Logo component that displays the application logo and links to the home page.
 * 
 * @param {Object} props - Component props.
 * @param {Function} props.onClick - Callback function to handle click events (e.g., resetting search).
 */
export default function Logo({ onClick }) {
    return (
        <Link to="/" className="flex items-center">
            <img
                className="max-w-full aspect-[4.76] w-[130px] hover:cursor-pointer"
                src={logo}
                alt="Logo"
                onClick={onClick}
            />
        </Link>
    );
}
